import { useEffect, useRef, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { config } from '../config';

export function useSocket() {
  const socketRef = useRef<Socket | null>(null);
  const [stats, setStats] = useState({
    deviceAmount: 0,
    routerAmount: 0,
    todayDnsRecordsAmount: 0,
    todayThreatsAmount: 0,
  });

  useEffect(() => {
    const token = localStorage.getItem('loginToken');
    if (!token) {
      console.error('❌ Token not found in localStorage');
      return;
    }


    const socket = io(config.SOCKET_URL || '', {

      extraHeaders: {
        token: token,
      },
    });

    socketRef.current = socket;

    socket.on('connect', () => {
      console.log('Connected to WebSocket:', socket.id);
    });

    socket.on('connect_error', (err) => {
      console.error('WebSocket error:', err.message);
    });

    socket.on('disconnect', (reason) => {
      console.warn('WebSocket disconnected:', reason);
    });

    // Incoming data listeners
    socket.on('deviceAmount', (deviceAmount: number) =>
      setStats((prev) => ({ ...prev, deviceAmount }))
    );

    socket.on('routerAmount', (routerAmount: number) =>
      setStats((prev) => ({ ...prev, routerAmount }))
    );

    socket.on('todayDnsRecordsAmount', (todayDnsRecordsAmount: number) =>
      setStats((prev) => ({ ...prev, todayDnsRecordsAmount }))
    );

    socket.on('todayThreatsAmount', (todayThreatsAmount: number) =>
      setStats((prev) => ({ ...prev, todayThreatsAmount }))
    );

    return () => {
      socket.disconnect();
    };
  }, []);

  return stats;
}
